import AllowedPrefixes from "@/modules/allowList/views/AllowListView.vue";

export const AllowedPrefixesRouter = [
    {
        path: '/prefix/allowlist',
        component: AllowedPrefixes,
    }
]